export enum PageSubscriptionRewardsActionTypes {
  GET_PAGE_SUBSCRIPTION_REWARDS_REQUEST = 'page-subscription-rewards/GET_PAGE_SUBSCRIPTION_REWARDS_REQUEST',
  GET_PAGE_SUBSCRIPTION_REWARDS_SUCCESS = 'page-subscription-rewards/GET_PAGE_SUBSCRIPTION_REWARDS_SUCCESS',
  GET_PAGE_SUBSCRIPTION_REWARDS_ERROR = 'page-subscription-rewards/GET_PAGE_SUBSCRIPTION_REWARDS_ERROR',
  PLAY_REWARD_REQUEST = 'page-subscription-rewards/PLAY_REWARD_REQUEST',
  PLAY_REWARD_SUCCESS = 'page-subscription-rewards/PLAY_REWARD_SUCCESS',
  PLAY_REWARD_ERROR = 'page-subscription-rewards/PLAY_REWARD_ERROR',
}
